import '../../_helpers/sort-by.js'
export const listConnectionTypes = [
    {value:'WIFI', label:'Wi-Fi'},
    {value:'CELLULAR', label:'Cellular'}
].sortBy('label')